<template>
    <app-layout title="Settings">
        <form @submit.prevent="submitForm">
            <page-header>
                <template #title>Settings - Order Limits</template>

                <template #actions>
                    <div v-if="changed">
                        <jet-button type="submit" class="h-7 leading-none mr-2">
                            Save
                        </jet-button>

                        <jet-tertiary-button ref="reload" :href="route('settings.limit.index')">
                            Cancel
                        </jet-tertiary-button>
                    </div>
                </template>
            </page-header>

            <settings-navigation />

            <div class="px-8 mt-2">
                <div class="bg-blue-200 text-center font-bold px-4 py-3 rounded-md" role="alert">
                    <b>Default limits:</b>
                    <table style="margin: 0px auto;" class="text-left small text-sm">
                        <thead>
                            <tr>
                                <th class="px-4 py-0">Mon-Fri</th>
                                <th class="px-4 py-0">Sat</th>
                            </tr>
                        </thead>
                        <tbody class="font-thin">
                            <tr>
                                <td class="px-4 py-0">
                                    <div>Early Morning: 50</div>
                                    <div>Late Morning: 150</div>
                                    <div>Early Afternoon: 150</div>
                                    <div>Late Afternoon/Evening: 150</div>
                                </td>
                                <td class="px-4 py-0">
                                    <div>Early Morning: 50</div>
                                    <div>Late Morning: 150</div>
                                    <div>Early Afternoon: 150</div>
                                    <div>Late Afternoon/Evening: -</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="mt-4 rounded-t border border-b-0">
                    <div class="flex mt-2 mb-2">
                        <jet-button type="button" class="h-7 leading-none ml-auto mr-2" @click="addLimit()" >
                            Add limit
                        </jet-button>
                    </div>

                    <table class="table w-full">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Limit</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(limit, index) in _limits" :key="index" class="cursor-pointer">
                                <td class="text-left">
                                    <jet-input v-model="limit.date" @change="changed = true" type="date" required />
                                </td>

                                <td class="text-left">
                                    <multiselect
                                        v-model="limit.time"
                                        :options="times"
                                        :closeOnSelect="true"
                                        :canClear="false"
                                        :classes="{ singleLabel: 'w-full px-2' }"
                                        @change="changed = true"
                                        required
                                    />
                                </td>

                                <td class="text-left">
                                    <jet-input v-model="limit.limit" @change="changed = true" :step="1" type="number" class="w-full" required />
                                </td>

                                <td class="text-right">
                                    <jet-danger-button class="mx-4" @click="deleteLimit(index)">
                                        Delete
                                    </jet-danger-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Delete Limit -->
            <jet-confirmation-modal :show="showDeleteModal" @close="showDeleteModal = false">
                <template #title>
                    Delete Order Limit
                </template>

                <template #content>
                    Are you sure you would like to delete limit?
                </template>

                <template #footer>
                    <jet-danger-button @click="handleDeleteLimit">
                        Yes
                    </jet-danger-button>

                    <jet-tertiary-button class="ml-2" @click="showDeleteModal = false">
                        No
                    </jet-tertiary-button>
                </template>
            </jet-confirmation-modal>
        </form>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetLabel from '@/Jetstream/Label';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError.vue';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetButton from '@/Jetstream/Button';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import SettingsNavigation from '@/Pages/Settings/Partials/SettingsNavigation';
import Multiselect from '@vueform/multiselect';

import '@vueform/multiselect/themes/default.css';

export default {
    components: {
        AppLayout,
        PageHeader,
        JetLabel,
        JetInput,
        JetInputError,
        JetDialogModal,
        JetConfirmationModal,
        JetButton,
        JetDangerButton,
        JetTertiaryButton,
        SettingsNavigation,
        Multiselect,
    },

    props: [
        'limits',
    ],

    data() {
        return {
            _limits: this.limits,
            showDeleteModal: false,
            changed: false,
            index: null,
            times: {
                early_morning: 'Early Morning',
                late_morning: 'Late Morning',
                early_afternoon: 'Early Afternoon',
                late_afternoon: 'Late Afternoon/Evening',
            }
        }
    },

    methods: {
        addLimit() {
            this.changed = true;
            this._limits.push({
                date: new Date().toISOString().split('T')[0],
                time: 'early_morning',
                limit: 100,
            });
        },

        submitForm() {
            this.$inertia.post(route('settings.limit.store'), { limits: this._limits }, {
                preserveScroll: true,
                resetOnSuccess: true,
            })

            this.changed = false;
        },

        deleteLimit(index) {
            this.index = index;
            this.showDeleteModal = true;
        },

        handleDeleteLimit() {
            this._limits.splice(this.index, 1);
            this.showDeleteModal = false;
            this.index = null;
            this.changed = true;
        },
    },
}
</script>

<style scoped>
</style>
